import {
  type CompositionV3Filters,
  PositionsEntityKind,
} from '@revelio/data-access';

const ROLE_LEVEL_FILTER_KEYS: Array<keyof CompositionV3Filters> = [
  'role_level_7',
  'role_level_6',
  'role_level_5',
  'role_level_4',
  'role_level_3',
  'role_level_2',
  'role_level_1',
];

function hasRoleSelections(
  compositionFilters: CompositionV3Filters,
  key: keyof CompositionV3Filters
): boolean {
  const value = compositionFilters[key];
  return Array.isArray(value) && value.length > 0;
}

function getDeepestRoleLevel(
  compositionFilters: CompositionV3Filters
): keyof CompositionV3Filters | null {
  return (
    ROLE_LEVEL_FILTER_KEYS.find((key) =>
      hasRoleSelections(compositionFilters, key)
    ) ?? null
  );
}

export function getSegmentEntityType({
  secondaryDimension,
  compositionFilters,
}: {
  secondaryDimension: 'geography' | 'role';
  compositionFilters: CompositionV3Filters;
}): PositionsEntityKind | null {
  if (secondaryDimension === 'geography') {
    if (hasRoleSelections(compositionFilters, 'region')) {
      return PositionsEntityKind.Country;
    }
    if (hasRoleSelections(compositionFilters, 'country')) {
      return PositionsEntityKind.Msa;
    }
    if (hasRoleSelections(compositionFilters, 'msa')) {
      return PositionsEntityKind.City;
    }
    if (hasRoleSelections(compositionFilters, 'city')) {
      return PositionsEntityKind.City;
    }

    return PositionsEntityKind.Region;
  }

  if (secondaryDimension === 'role') {
    const deepestLevel = getDeepestRoleLevel(compositionFilters);
    if (deepestLevel === null) {
      return PositionsEntityKind.RoleK7;
    }
    if (deepestLevel === 'role_level_1' || deepestLevel === 'role_level_2') {
      return PositionsEntityKind.RoleK150;
    }
    if (deepestLevel === 'role_level_3' || deepestLevel === 'role_level_4') {
      return PositionsEntityKind.RoleK1500;
    }
    if (deepestLevel === 'role_level_5' || deepestLevel === 'role_level_6') {
      return PositionsEntityKind.RoleK15000;
    }

    return null;
  }

  return null;
}
